import { render } from "./PageTrendRadar.vue?vue&type=template&id=51c35e46"
import script from "./PageTrendRadar.vue?vue&type=script&lang=js"
export * from "./PageTrendRadar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__